import { gsap } from 'gsap';

if (document.querySelector('.clients-sec__row-marquee')) {
  let currentScroll = window.pageYOffset;
  let isScrollingDown = true;
  let scrollTimeout;

  document.querySelectorAll('.clients-sec__row-marquee').forEach((row) => {
    const track = row.querySelector('.clients-sec__row-track');
    const content = track.querySelector('.clients-sec__row-content');

    // Клонируем несколько раз
    const clone = content.cloneNode(true);
    track.appendChild(clone);
    track.appendChild(clone);
    track.appendChild(clone);

    const contentWidth = content.offsetWidth;

    gsap.set(track, { x: -contentWidth });

    const tween = gsap.to(track, {
      x: `-=${contentWidth}`,
      duration: 55,
      ease: 'linear',
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize((x) => parseFloat(x) % contentWidth),
      },
    });

    tween.totalProgress(0.5);

    // Логика на скролл
    window.addEventListener('scroll', () => {
      const newScroll = window.pageYOffset;
      isScrollingDown = newScroll > currentScroll;
      currentScroll = newScroll;

      gsap.to(tween, {
        timeScale: isScrollingDown ? 2 : -2,
        overwrite: true,
        duration: 0.2,
      });

      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        gsap.to(tween, {
          timeScale: isScrollingDown ? 1 : -1,
          duration: 0.5,
          ease: 'power2.out',
        });
      }, 300);
    });

    row.querySelectorAll('.clients-sec__row-services-logo').forEach((logo) => {
      logo.addEventListener('mouseenter', () => {
        tween.pause();
      });
      logo.addEventListener('mouseleave', () => {
        tween.resume();
      });
    });
  });
}
